import { http } from "./config";

export default {
  //#region Terminals
  searchTerminals: () => {
    let regionId = JSON.parse(localStorage.getItem("currentRegion")).id;
    let request = {
      key: null,
      type: null,
      isActive: null,
      regionId: regionId,
    };

    return http.post("api/v1/terminal/search", request);
  },
  insertTerminal: (terminal) => {
    return http.post("api/v1/terminal/insert", terminal);
  },
  updateTerminal: (terminal) => {
    return http.post("api/v1/terminal/update", terminal);
  },
  deleteTerminal: (idTerminal) => {
    return http.post("api/v1/terminal/delete?id=" + idTerminal);
  },
  //#endregion

  //#region Regions
  searchRegions: (filters = {}) => {
    return http.post("api/v1/region/search", filters);
  },
  getRegionById: (id) => {
    return http.get("api/v1/region/getbyid?id=" + id);
  },
  insertRegion: (region) => {
    return http.post("api/v1/region/insert", region);
  },
  updateRegion: (region) => {
    return http.post("api/v1/region/update", region);
  },
  deleteRegion: (idRegion) => {
    return http.post("api/v1/region/delete?id=" + idRegion);
  },
  toggleRegionActive: (idRegion) => {
    return http.patch(`api/v1/region/ToggleActive/${idRegion}`);
  },
  //#endregion

  //#region Lotteries
  searchLotteries: () => {
    return http.post("api/v1/lottery/search", {
      includes: [0] // 0 = Details (horários)
    });
  },
  getById: (id) => {
    return http.get("api/v1/lottery/getbyid?id=" + id);
  },
  insertLottery: (lottery) => {
    return http.post("api/v1/lottery/insert", lottery);
  },
  updateLottery: (lottery) => {
    return http.post("api/v1/lottery/update", lottery);
  },
  deleteLottery: (idLottery) => {
    return http.post("api/v1/lottery/delete?id=" + idLottery);
  },
  //#endregion

  //#region Predictions
  searchPredictions: (lotteryDetailId, regionId = null, date = null, number = null, awardMoreThan = null) => {
    const params = new URLSearchParams({
      LotteryDetailId: lotteryDetailId
    });

    if (regionId) {
      params.append('RegionId', regionId);
    }

    if (date) {
      params.append('Date', date);
    }

    if (number) {
      params.append('Number', number);
    }

    if (awardMoreThan !== null && awardMoreThan !== undefined && !isNaN(awardMoreThan) && parseFloat(awardMoreThan) > 0) {
      params.append('AwardMoreThan', parseFloat(awardMoreThan).toString());
    }

    return http.get(`api/v1/bet/prediction?${params}`);
  },
  //#endregion

  //#region Descargas Enviadas
  searchDescargasSent: (regionId, startDateTime, endDateTime) => {
    const request = {
      IdRegion: regionId,
      StartDateTime: startDateTime,
      EndDateTime: endDateTime
    };

    return http.post("api/v1/descarga/sent", request);
  },
  //#endregion

  //#region Histórico de Descargas (nova tabela DescargaBets)
  searchDescargaBetHistory: (regionId, date, lotteryDetailId = null, number = null, status = null, hierarchyLevel = null, endDate = null) => {
    let params = `regionId=${regionId}&date=${date}`;
    if (endDate) {
      params += `&endDate=${endDate}`;
    }
    if (lotteryDetailId) {
      params += `&lotteryDetailId=${lotteryDetailId}`;
    }
    if (number) {
      params += `&number=${number}`;
    }
    if (status) {
      params += `&status=${status}`;
    }
    if (hierarchyLevel) {
      params += `&hierarchyLevel=${hierarchyLevel}`;
    }
    return http.get(`api/v1/descarga/history?${params}`);
  },
  //#endregion

  //#region Descargas Recebidas
  searchDescargasReceived: (currentRegionId, regionIds, startDateTime, endDateTime) => {
    const request = {
      IdCurrentRegion: currentRegionId,
      IdRegions: regionIds,
      StartDateTime: startDateTime,
      EndDateTime: endDateTime
    };

    return http.post("api/v1/descarga/received", request);
  },
  //#endregion

  //#region Modalities
  searchModalities: () => {
    return http.post("api/v1/modality/search", {});
  },
  //#endregion

  //#region Sellers
  searchSellers: () => {
    let regionId = JSON.parse(localStorage.getItem("currentRegion")).id;
    let request = {
      regionId: regionId,
    };
    return http.post("api/v1/seller/search", request);
  },
  searchAllSellers: () => {
    return http.post("api/v1/seller/search", {
      name: null,
      isActive: null,
      regionId: null,
      idRegionDescarga: null,
      login: null
    });
  },
  searchSellersByRegion: (regionId) => {
    let request = {
      regionId: regionId || null
    };
    return http.post("api/v1/seller/search", request);
  },
  getSellersByCollector: (collectorId) => {
    return http.get("api/v1/seller/GetSellersByCollector", {
      params: { collectorId },
    });
  },
  insertSeller: (seller) => {
    return http.post("api/v1/seller/insert", seller);
  },
  updateSeller: (seller) => {
    return http.post("api/v1/seller/update", seller);
  },
  toggleSellerStatus: (sellerId, isActive) => {
    return http.post(`api/v1/seller/toggleStatus`, { id: sellerId, isActive: isActive });
  },
  deleteSeller: (idSeller) => {
    return http.post("api/v1/seller/delete?id=" + idSeller);
  },
  getSellerById: (id) => {
    return http.get("api/v1/seller/getbyid?id=" + id);
  },
  checkLoginExists: (login, excludeId = null) => {
    let url = "api/v1/seller/CheckLoginExists?login=" + encodeURIComponent(login);
    if (excludeId) {
      url += "&excludeId=" + excludeId;
    }
    return http.get(url);
  },
  //#region Balance
  searchBalanceSeller: (idSeller, startDate, endDate) => {
     let regionId = JSON.parse(localStorage.getItem("currentRegion")).id;
     // Codificar as datas para garantir que sejam enviadas corretamente
     const encodedStartDate = encodeURIComponent(startDate);
     const encodedEndDate = encodeURIComponent(endDate);
    return http.get("api/v1/seller/balance?idSeller=" + idSeller + "&" + "regionId=" + regionId + "&" + "startDate=" + encodedStartDate + "&" + "endDate=" + encodedEndDate);
  },
  //#endregion

  //#region RegionsConfigs
  searchRegionConfigs: () => {
    let currentRegion = JSON.parse(localStorage.getItem("currentRegion"));
    if (!currentRegion || !currentRegion.id) {
      throw new Error("Nenhuma região selecionada");
    }
    let request = {
      regionId: currentRegion.id,
    };
    return http.post("api/v1/regionparameter/search", request);
  },
  saveRegionConfigs: (regionParameter) => {
    return http.post("api/v1/regionparameter/save", regionParameter);
  },
  copyRegionConfigs: (sourceRegionId, targetRegionId) => {
    return http.post("api/v1/regionparameter/copy", {
      sourceRegionId,
      targetRegionId,
    });
  },
  searchRegionLotteryCotacao: () => {
    let currentRegion = JSON.parse(localStorage.getItem("currentRegion"));
    if (!currentRegion || !currentRegion.id) {
      throw new Error("Nenhuma região selecionada");
    }
    return http.post("api/v1/regionlottery/search", { regionId: currentRegion.id });
  },
  saveRegionLotteryCotacao: (payload) => {
    return http.post("api/v1/regionlottery/save", payload);
  },
  searchRegionModalities: (regionId) => {
    let id = regionId;
    if (!id) {
      try {
        const currentRegion = JSON.parse(localStorage.getItem("currentRegion") || "null");
        id = currentRegion?.id;
      } catch {
        id = null;
      }
    }
    if (!id) {
      return Promise.reject(new Error("Nenhuma região selecionada"));
    }
    return http.post("api/v1/RegionParameter/RegionModalityParameter/Search", {
      regionId: id,
    });
  },
  //#endregion

  //#region Balance
  searchBalance: (request) => {
    return http.post("api/v1/balance/search", request);
  },
  searchSellerBalance: (request) => {
    return http.post("api/v1/seller/balance/search", request);
  },
  searchSellerLotteryHistory: (request) => {
    return http.post("api/v1/seller/lottery-history", request);
  },
  searchBalanceBets: (params) => {
    return http.get("api/v1/bet/SearchBets?" + params);
  },
  searchBetById: (betId) => {
    return http.get("api/v1/bet/SearchBetById?id=" + betId);
  },
  searchBetsBySeller: (params) => {
    return http.get("api/v1/bet/SearchBetsBySeller?" + params);
  },
  searchBetsByRegion: (params) => {
    return http.get("api/v1/bet/SearchBets?" + params);
  },
  cancelBet: (betId, userId, cancelReason = null) => {
    const request = {
      betId: betId,
      userId: userId,
      cancelReason: cancelReason
    };
    return http.post("api/v1/bet/Cancel", request);
  },
  claimPrize: (betId, userId, pin) => {
    const request = {
      betId: betId,
      userId: userId,
      pin: pin
    };
    return http.post("api/v1/bet/ClaimPrize", request);
  },
  claimPrizeByBanca: (betId, userId, pin) => {
    const request = {
      betId: betId,
      userId: userId,
      pin: pin
    };
    return http.post("api/v1/bet/ClaimPrizeByBanca", request);
  },
  consultBetByPin: (pin, regionId) => {
    return http.get(`api/v1/bet/ConsultBetByPin?pin=${pin}&regionId=${regionId}`);
  },
  //#endregion

  //#region Results
  searchLotteryResults: (searchDateFrom, searchDateTo, pageIndex, regionId = null, lotteryId = null) => {
    let request = {
      dateFrom: searchDateFrom,
      dateTo: searchDateTo,
      pageIndex: pageIndex
    };
    
    // Adicionar regionId se fornecido
    if (regionId) {
      request.regionId = regionId;
    }
    
    // Adicionar lotteryId se fornecido
    if (lotteryId) {
      request.lotteryId = lotteryId;
    }
    
    return http.post("api/v1/LotteryResults/searchPaginated", request);
  },
  getLotteryResultsById: (id) => {
    return http.get("api/v1/LotteryResults/getbyid?id=" + id);
  },
  insertLotteryResults: (lotteryResults) => {
    return http.post("api/v1/LotteryResults/insert", lotteryResults);
  },
  updateLotteryResults: (lotteryResults) => {
    return http.post("api/v1/LotteryResults/update", lotteryResults);
  },
  deleteLotteryResults: (id) => {
    return http.post("api/v1/LotteryResults/delete?id=" + id);
  },
  processLotteryResult: (id) => {
    return http.post("api/v1/LotteryResults/process?id=" + id);
  },
  getWinningTickets: (lotteryResultId, regionId = null) => {
    let url = "api/v1/lottery-results/" + lotteryResultId + "/winning-tickets";
    
    // Adicionar regionId como query parameter se fornecido
    if (regionId) {
      url += "?regionId=" + regionId;
    }
    
    return http.get(url);
  },
  fetchExternalResults: (state, date) => {
    return http.get(`api/v1/lottery-results/external/fetch?state=${state}&date=${date}`);
  },
  importExternalResult: (state, date, lotteryDetailId, numbers = null) => {
    const url = `api/v1/lottery-results/external/import?state=${state}&date=${date}&lotteryDetailId=${lotteryDetailId}`;
    const body = numbers ? { numbers } : {};
    return http.post(url, body);
  },
  //#endregion

  //#region FinancialTransactions
  searchFinancialTransactions: (filters) => {
      const regionId =  JSON.parse(localStorage.getItem("currentRegion")).id;
      const payload = { ...filters, RegionId: regionId };
    return http.post("api/v1/FinancialTransactions/search", payload);
  },
  searchFinancialTransactionsByRegion: (filters) => {
    // Buscar transações por região específica sem usar localStorage
    return http.post("api/v1/FinancialTransactions/search", filters);
  },
  getFinancialTransactionsById: (id) => {
    return http.get("api/v1/FinancialTransactions/getbyid?id=" + id);
  },
  insertFinancialTransactions: (financialTransactions) => {
    // O RegionId já vem do frontend, não precisa sobrescrever
    return http.post("api/v1/FinancialTransactions/insert", financialTransactions);
  },
  updateFinancialTransactions: (financialTransactions) => {
    return http.post("api/v1/FinancialTransactions/update", financialTransactions);
  },
  deleteFinancialTransactions: (id) => {
    return http.post("api/v1/FinancialTransactions/delete?id=" + id);
  },
  approveDescarga: (transactionId) => {
    return http.post("api/v1/FinancialTransactions/ApproveDescarga?id=" + transactionId);
  },
  rejectDescarga: (transactionId) => {
    return http.post("api/v1/FinancialTransactions/RejectDescarga?id=" + transactionId);
  },
  //#endregion

  //#region User

  login: (user) => {
    return http.post("api/v1/user/Login", user);
  },

  resetPassword: (user) => {
    return http.post("api/v1/user/ResetPassword", user);
  },

  searchUsers: (request = null) => {
    return http.post("api/v1/user/Search", request);
  },

  getUserById: (id) => {
    return http.get("api/v1/user/" + id);
  },

  insertUser: async (user) => {
    // Validações no frontend ANTES de enviar
    if (!user.name || user.name.trim() === '') {
      throw new Error('O nome do usuário é obrigatório!');
    }
    
    if (!user.username || user.username.trim() === '') {
      throw new Error('O nome de usuário é obrigatório!');
    }
    
    if (!user.password || user.password.trim() === '') {
      throw new Error('A senha é obrigatória!');
    }
    
    if (user.password.length < 6) {
      throw new Error('A senha deve ter pelo menos 6 caracteres!');
    }
    
    if (!user.role && user.role !== 0) {
      throw new Error('É necessário selecionar um tipo/papel para o usuário!');
    }
    
    // REMOVIDO: Validação de regionId obrigatório - usuário pode ser criado sem região
    // A região pode ser associada posteriormente
    
    console.log('[DEBUG insertUser] Request:', JSON.stringify(user, null, 2));
    
    try {
      return await http.post("api/v1/user/Insert", user);
    } catch (error) {
      // Interceptar erros 400 do backend e traduzir mensagens
      if (error.response && error.response.status === 400) {
        const errorMessage = error.response.data?.message || 
                             error.response.data?.errors?.[0]?.message ||
                             JSON.stringify(error.response.data);
        
        // Traduzir erros comuns do backend
        if (errorMessage.includes('username') || errorMessage.includes('Username')) {
          throw new Error('Este nome de usuário já existe! Por favor, escolha outro.');
        }
        if (errorMessage.includes('region') || errorMessage.includes('Region')) {
          throw new Error('Região inválida! Por favor, selecione uma região válida.');
        }
        if (errorMessage.includes('password') || errorMessage.includes('Password')) {
          throw new Error('Senha inválida! A senha deve ter pelo menos 6 caracteres.');
        }
        if (errorMessage.includes('role') || errorMessage.includes('Role')) {
          throw new Error('Tipo de usuário inválido! Por favor, selecione um tipo válido.');
        }
        
        throw new Error(`Erro ao criar usuário: ${errorMessage}`);
      }
      
      // Re-lançar outros erros
      throw error;
    }
  },

  registerAdmin: (user) => {
    return http.post("api/v1/user/RegisterAdmin", user);
  },

  updateUser: async (user) => {
    // Validações no frontend ANTES de enviar
    if (!user.id) {
      throw new Error('ID do usuário é obrigatório para atualização!');
    }
    
    if (!user.name || user.name.trim() === '') {
      throw new Error('O nome do usuário é obrigatório!');
    }
    
    if (!user.username || user.username.trim() === '') {
      throw new Error('O nome de usuário é obrigatório!');
    }
    
    // Senha é opcional na atualização, mas se fornecida, deve ter pelo menos 6 caracteres
    if (user.password && user.password.trim() !== '' && user.password.length < 6) {
      throw new Error('A senha deve ter pelo menos 6 caracteres!');
    }
    
    if (!user.role && user.role !== 0) {
      throw new Error('É necessário selecionar um tipo/papel para o usuário!');
    }
    
    // REMOVIDO: Validação de regionId obrigatório - usuário pode existir sem região
    // A região pode ser associada posteriormente
    
    console.log('[DEBUG updateUser] Request:', JSON.stringify(user, null, 2));
    
    try {
      return await http.put("api/v1/user/Update", user);
    } catch (error) {
      // Interceptar erros 400 do backend e traduzir mensagens
      if (error.response && error.response.status === 400) {
        const errorMessage = error.response.data?.message || 
                             error.response.data?.errors?.[0]?.message ||
                             JSON.stringify(error.response.data);
        
        // Traduzir erros comuns do backend
        if (errorMessage.includes('username') || errorMessage.includes('Username')) {
          throw new Error('Este nome de usuário já existe! Por favor, escolha outro.');
        }
        if (errorMessage.includes('region') || errorMessage.includes('Region')) {
          throw new Error('Região inválida! Por favor, selecione uma região válida.');
        }
        if (errorMessage.includes('password') || errorMessage.includes('Password')) {
          throw new Error('Senha inválida! A senha deve ter pelo menos 6 caracteres.');
        }
        if (errorMessage.includes('role') || errorMessage.includes('Role')) {
          throw new Error('Tipo de usuário inválido! Por favor, selecione um tipo válido.');
        }
        
        throw new Error(`Erro ao atualizar usuário: ${errorMessage}`);
      }
      
      // Re-lançar outros erros
      throw error;
    }
  },

  deleteUser: (id) => {
    return http.delete("api/v1/user/" + id);
  },

  activateUser: (id) => {
    return http.post("api/v1/user/Activate/" + id);
  },

  deactivateUser: (id) => {
    return http.post("api/v1/user/Deactivate/" + id);
  },

  getUserResponsibleRegions: (userId) => {
    return http.get("api/v1/user/ResponsibleRegions/" + userId);
  },

  getUserBancaId: (userId) => {
    return http.get("api/v1/user/" + userId + "/bancaId");
  },

  assignRegionToUser: (request) => {
    return http.post("api/v1/user/AssignRegion", request);
  },

  removeRegionFromUser: (request) => {
    return http.post("api/v1/user/RemoveRegionFromUser", request);
  },

  getUserRegions: (userId) => {
    return http.get("api/v1/user/ResponsibleRegions/" + userId);
  },

  getUserRegionsWithLinked: (userId) => {
    return http.get("api/v1/user/UserRegionsWithLinked/" + userId);
  },

  getBancaRegionsWithLinked: (bancaId) => {
    return http.get("api/v1/user/BancaRegionsWithLinked/" + bancaId);
  },
  //#endregion

  //#region Collectors
  searchCollectors: (filters = {}) => {
    // filters opcional: { regionId } para filtrar pela unidade/região selecionada
    let request = { ...(filters || {}) };
    return http.post("api/v1/user/SearchCollectors", request);
  },

  insertCollector: async (collector) => {
    // Validações no frontend ANTES de enviar
    if (!collector.name || collector.name.trim() === '') {
      throw new Error('O nome do cobrador é obrigatório!');
    }
    
    if (!collector.username || collector.username.trim() === '') {
      throw new Error('O nome de usuário é obrigatório!');
    }
    
    if (!collector.password || collector.password.trim() === '') {
      throw new Error('A senha é obrigatória!');
    }
    
    if (collector.password.length < 3) {
      throw new Error('A senha deve ter pelo menos 3 caracteres!');
    }
    
    if (!collector.regionId) {
      throw new Error('É necessário selecionar uma região para o cobrador!');
    }
    
    // Mapear campos do collector para UserInsertRequest
    let request = {
      name: collector.name,
      username: collector.username,
      password: collector.password,
      phone: collector.phone,
      regionId: collector.regionId,
      bancaId: collector.bancaId || null,
      BancaId: collector.bancaId || null
    };
    
    console.log('[DEBUG insertCollector] Request:', JSON.stringify(request, null, 2));
    
    try {
      return await http.post("api/v1/user/InsertCollector", request);
    } catch (error) {
      // Interceptar erros 400 do backend e traduzir mensagens
      if (error.response && error.response.status === 400) {
        const errorMessage = error.response.data?.message || 
                             error.response.data?.errors?.[0]?.message ||
                             JSON.stringify(error.response.data);
        
        // Traduzir erros comuns do backend
        if (errorMessage.includes('username') || errorMessage.includes('Username')) {
          throw new Error('Este nome de usuário já existe! Por favor, escolha outro.');
        }
        if (errorMessage.includes('region') || errorMessage.includes('Region')) {
          throw new Error('Região inválida! Por favor, selecione uma região válida.');
        }
        if (errorMessage.includes('password') || errorMessage.includes('Password')) {
          throw new Error('Senha inválida! A senha deve ter pelo menos 3 caracteres.');
        }
        
        throw new Error(`Erro ao criar cobrador: ${errorMessage}`);
      }
      
      // Re-lançar outros erros
      throw error;
    }
  },

  updateCollector: (collector) => {
    // Mapear campos do collector para UserUpdateRequest
    let request = {
      id: collector.id,
      name: collector.name,
      username: collector.username || collector.name.toLowerCase().replace(/\s+/g, ''),
      phone: collector.phone,
      isActive: collector.active,
      regionId: collector.regionId,
      bancaId: collector.bancaId || null,
      BancaId: collector.bancaId || null
    };
    
    // Incluir senha apenas se foi fornecida (não vazia)
    if (collector.password && collector.password.trim() !== '') {
      request.password = collector.password;
    }
    
    return http.post("api/v1/user/UpdateCollector", request);
  },

  deleteCollector: (id) => {
    return http.post("api/v1/user/DeleteCollector?id=" + id);
  },

  getCollectorById: (id) => {
    return http.get("api/v1/user/GetCollectorById?id=" + id);
  },

  // Comissões de Cobradores
  searchCollectorCommissions: (filters) => {
    return http.post("api/v1/collector/commissions/search", filters);
  },

  // Histórico de Cobradores
  searchCollectorHistory: (filters) => {
    return http.post("api/v1/collector/history/search", filters);
  },

  // Pagamentos de Cobradores
  createCollectorPayment: (payment) => {
    return http.post("api/v1/collector/payments", payment);
  },
  getCollectorPayments: (collectorId) => {
    return http.get(`api/v1/collector/payments/collector/${collectorId}`);
  },
  getCollectorPaymentSummary: (collectorId) => {
    return http.get(`api/v1/collector/payments/summary/${collectorId}`);
  },
  searchCollectorPayments: (filters) => {
    return http.post("api/v1/collector/payments/search", filters);
  },

  // Fechamento banca ↔ cobrador (Líquido Prêmio) — módulo isolado
  previewCollectorSettlement: (request) => {
    return http.post("api/v1/collector/settlements/preview", request);
  },
  createCollectorSettlement: (request) => {
    return http.post("api/v1/collector/settlements", request);
  },
  getCollectorSettlementById: (id) => {
    return http.get(`api/v1/collector/settlements/${id}`);
  },
  searchCollectorSettlements: (filters) => {
    return http.post("api/v1/collector/settlements/search", filters);
  },
  addCollectorSettlementPayment: (settlementId, payment) => {
    return http.post(`api/v1/collector/settlements/${settlementId}/payments`, payment);
  },
  deleteCollectorSettlement: (settlementId) => {
    return http.delete(`api/v1/collector/settlements/${settlementId}`);
  },

  searchCollectorCharges: (filters) => {
    return http.post("api/v1/collector/charges/search", filters);
  },
  summaryCollectorCharges: (filters) => {
    return http.post("api/v1/collector/charges/summary", filters);
  },
  /** Vendedores com/sem cobrança no período + última cobrança. */
  sellersCoverageCollectorCharges: (filters) => {
    return http.post("api/v1/collector/charges/sellers-coverage", filters);
  },
  //#endregion

  //#region Settings
  getActiveSettings: () => {
    return http.get("api/v1/settings/active");
  },
  searchSettings: (filters) => {
    return http.post("api/v1/settings/search", filters);
  },
  insertSettings: (settings) => {
    return http.post("api/v1/settings/insert", settings);
  },
  updateSettings: (settings) => {
    return http.put("api/v1/settings/update", settings);
  },
  deleteSettings: (id) => {
    return http.delete("api/v1/settings/" + id);
  },
  getSettingsById: (id) => {
    return http.get("api/v1/settings/" + id);
  },
  //#endregion

  //#region Bancas
  searchBancas: (request) => {
    return http.post("api/v1/banca/search", request);
  },
  insertBanca: (banca) => {
    return http.post("api/v1/banca/insert", banca);
  },
  updateBanca: (banca) => {
    return http.post("api/v1/banca/update", banca);
  },
  deleteBanca: (idBanca) => {
    return http.post("api/v1/banca/delete?id=" + idBanca);
  },
  getBancaById: (id) => {
    return http.get("api/v1/banca/getbyid?id=" + id);
  },
  getBancasWithUsersAndRegions: () => {
    return http.get("api/v1/banca/getbancaswithusersandregions");
  },
  getBancaWithUsersAndRegionsById: (id) => {
    return http.get("api/v1/banca/getbancawithusersandregionsbyid?id=" + id);
  },
  getNextBancaCode: () => {
    return http.get("api/v1/banca/getnextcode");
  },
  //#endregion

  //#region WhatsApp
  searchWhatsAppConfigs: (filters) => {
    return http.post("api/v1/whatsapp/config/search", filters);
  },
  insertWhatsAppConfig: (config) => {
    return http.post("api/v1/whatsapp/config/insert", config);
  },
  updateWhatsAppConfig: (config) => {
    return http.put("api/v1/whatsapp/config/update", config);
  },
  deleteWhatsAppConfig: (id) => {
    return http.delete("api/v1/whatsapp/config/" + id);
  },
  getWhatsAppConfigById: (id) => {
    return http.get("api/v1/whatsapp/config/" + id);
  },
  getActiveWhatsAppConfig: () => {
    return http.get("api/v1/whatsapp/config/active");
  },
  testWhatsAppMessage: (request) => {
    return http.post("api/v1/whatsapp/config/test", request);
  },
  searchWhatsAppNumbers: (filters) => {
    return http.post("api/v1/whatsapp/number/search", filters);
  },
  insertWhatsAppNumber: (number) => {
    return http.post("api/v1/whatsapp/number/insert", number);
  },
  updateWhatsAppNumber: (number) => {
    return http.put("api/v1/whatsapp/number/update", number);
  },
  deleteWhatsAppNumber: (id, requestingUserId = null) => {
    const params = requestingUserId ? `?requestingUserId=${requestingUserId}` : '';
    return http.delete("api/v1/whatsapp/number/" + id + params);
  },
  getWhatsAppNumberById: (id) => {
    return http.get("api/v1/whatsapp/number/" + id);
  },
  // Relatórios
  searchWhatsAppReportTemplates: (filters) => {
    return http.post("api/v1/whatsapp/reporttemplate/search", filters);
  },
  insertWhatsAppReportTemplate: (template) => {
    return http.post("api/v1/whatsapp/reporttemplate/insert", template);
  },
  updateWhatsAppReportTemplate: (template) => {
    return http.put("api/v1/whatsapp/reporttemplate/update", template);
  },
  deleteWhatsAppReportTemplate: (id) => {
    return http.delete("api/v1/whatsapp/reporttemplate/" + id);
  },
  getWhatsAppReportTemplateById: (id) => {
    return http.get("api/v1/whatsapp/reporttemplate/" + id);
  },
  getActiveWhatsAppReportTemplate: () => {
    return http.get("api/v1/whatsapp/reporttemplate/active");
  },
  searchWhatsAppReportSchedules: (filters) => {
    return http.post("api/v1/whatsapp/reportschedule/search", filters);
  },
  insertWhatsAppReportSchedule: (schedule) => {
    return http.post("api/v1/whatsapp/reportschedule/insert", schedule);
  },
  updateWhatsAppReportSchedule: (schedule) => {
    return http.put("api/v1/whatsapp/reportschedule/update", schedule);
  },
  deleteWhatsAppReportSchedule: (id) => {
    return http.delete("api/v1/whatsapp/reportschedule/" + id);
  },
  getWhatsAppReportScheduleById: (id) => {
    return http.get("api/v1/whatsapp/reportschedule/" + id);
  },
  // Instâncias
  searchWhatsAppInstances: (filters) => {
    return http.post("api/v1/whatsapp/instance/search", filters);
  },
  insertWhatsAppInstance: (instance) => {
    return http.post("api/v1/whatsapp/instance/insert", instance);
  },
  updateWhatsAppInstance: (instance) => {
    return http.put("api/v1/whatsapp/instance/update", instance);
  },
  deleteWhatsAppInstance: (id) => {
    return http.delete("api/v1/whatsapp/instance/" + id);
  },
  getWhatsAppInstanceById: (id) => {
    return http.get("api/v1/whatsapp/instance/" + id);
  },
  getActiveWhatsAppInstance: () => {
    return http.get("api/v1/whatsapp/instance/active");
  },
  getWhatsAppInstanceQrCode: (id) => {
    return http.post("api/v1/whatsapp/instance/" + id + "/qrcode");
  },
  connectWhatsAppInstance: (id) => {
    return http.post("api/v1/whatsapp/instance/" + id + "/connect");
  },
  disconnectWhatsAppInstance: (id) => {
    return http.post("api/v1/whatsapp/instance/" + id + "/disconnect");
  },
  //#endregion

  //#region Telegram
  searchTelegramBots: (filters = {}) => http.post("api/v1/telegram/bot/search", filters),
  insertTelegramBot: (bot) => http.post("api/v1/telegram/bot/insert", bot),
  updateTelegramBot: (bot) => http.put("api/v1/telegram/bot/update", bot),
  deleteTelegramBot: (id) => http.delete("api/v1/telegram/bot/" + id),
  getActiveTelegramBot: () => http.get("api/v1/telegram/bot/active"),

  searchTelegramChats: (filters = {}) => http.post("api/v1/telegram/chat/search", filters),
  insertTelegramChat: (chat) => http.post("api/v1/telegram/chat/insert", chat),
  updateTelegramChat: (chat) => http.put("api/v1/telegram/chat/update", chat),
  deleteTelegramChat: (id) => http.delete("api/v1/telegram/chat/" + id),

  searchTelegramConfigs: (filters = {}) => http.post("api/v1/telegram/config/search", filters),
  insertTelegramConfig: (config) => http.post("api/v1/telegram/config/insert", config),
  updateTelegramConfig: (config) => http.put("api/v1/telegram/config/update", config),
  deleteTelegramConfig: (id) => http.delete("api/v1/telegram/config/" + id),
  getActiveTelegramConfig: () => http.get("api/v1/telegram/config/active"),
  testTelegramMessage: (request) => http.post("api/v1/telegram/config/test", request),

  searchTelegramReportTemplates: (filters = {}) => http.post("api/v1/telegram/reporttemplate/search", filters),
  insertTelegramReportTemplate: (template) => http.post("api/v1/telegram/reporttemplate/insert", template),
  updateTelegramReportTemplate: (template) => http.put("api/v1/telegram/reporttemplate/update", template),
  deleteTelegramReportTemplate: (id) => http.delete("api/v1/telegram/reporttemplate/" + id),

  searchTelegramReportSchedules: (filters = {}) => http.post("api/v1/telegram/reportschedule/search", filters),
  insertTelegramReportSchedule: (schedule) => http.post("api/v1/telegram/reportschedule/insert", schedule),
  updateTelegramReportSchedule: (schedule) => http.put("api/v1/telegram/reportschedule/update", schedule),
  deleteTelegramReportSchedule: (id) => http.delete("api/v1/telegram/reportschedule/" + id),
  //#endregion

  //#region API Clients (Multi-Tenant)
  searchApiClients: (filters = {}) => {
    return http.post("api/v1/integration/tenant/search", filters);
  },
  insertApiClient: (client) => {
    return http.post("api/v1/integration/tenant/insert", client);
  },
  updateApiClient: (client) => {
    return http.post("api/v1/integration/tenant/update", client);
  },
  deleteApiClient: (id) => {
    return http.post("api/v1/integration/tenant/delete?id=" + id);
  },
  getApiClientById: (id) => {
    return http.get("api/v1/integration/tenant/getbyid?id=" + id);
  },
  regenerateApiClientKeys: (id) => {
    return http.post("api/v1/integration/tenant/regenerate-keys?id=" + id);
  },
  //#endregion

  //#region Cache
  clearAllCache: () => {
    return http.post("api/v1/cache/clear-all");
  },
  //#endregion
};
